/**
 * WordPress Dependencies
 */
import { __ } from "@wordpress/i18n";
import { useSelect } from "@wordpress/data";
import { justifyCenter, justifyLeft, justifyRight } from "@wordpress/icons";
import {
	PanelBody,
	BaseControl,
	ColorPalette,
	__experimentalUnitControl as UnitControl,
	__experimentalToggleGroupControl as ToggleGroupControl,
	__experimentalToggleGroupControlOptionIcon as ToggleGroupControlOptionIcon,
	ButtonGroup,
	Button,
} from "@wordpress/components";
import CustomIcon from "../icons/";

function PlayButton(props) {
	const { attributes, setAttributes } = props;

	const { defaultColors } = useSelect((select) => {
		return {
			defaultColors:
				select("core/block-editor")?.getSettings()?.__experimentalFeatures
					?.color?.palette?.default,
		};
	});
	const playButtonShape = [
		{
			name: __("Square", "ghub-video-lightbox"),
			icon: <div className="ghub-button-shape ghub-square"></div>,
			id: "square",
		},
		{
			name: __("Rounded", "ghub-video-lightbox"),
			icon: <div className="ghub-button-shape ghub-rounded"></div>,
			id: "rounded",
		},

		{
			name: __("Rectangle", "ghub-video-lightbox"),
			icon: <div className="ghub-button-shape ghub-rectangle"></div>,
			id: "rectangle",
		},

		{
			name: __("Circle", "ghub-video-lightbox"),
			icon: <div className="ghub-button-shape ghub-circle"></div>,
			id: "circle",
		},

		{
			name: __("Octagon", "ghub-video-lightbox"),
			icon: <div className="ghub-button-shape ghub-octagon"></div>,
			id: "octagon",
		},

		{
			name: __("Bevel", "ghub-video-lightbox"),
			icon: <div className="ghub-button-shape ghub-bevel"></div>,
			id: "bevel",
		},
	];

	const justificationPositionOpt = [
		{
			label: __("Left", "ghub-video-lightbox"),
			icon: justifyLeft,
			value: "left",
		},

		{
			label: __("Center", "ghub-video-lightbox"),
			icon: justifyCenter,
			value: "center",
		},

		{
			label: __("Right", "ghub-video-lightbox"),
			icon: justifyRight,
			value: "right",
		},
	];

	const verticalPositionOpt = [
		{
			label: __("Top", "ghub-video-lightbox"),
			icon: <CustomIcon icon="verticalTop" />,
			value: "top",
		},

		{
			label: __("Center", "ghub-video-lightbox"),
			icon: <CustomIcon icon="verticalCenter" />,
			value: "center",
		},

		{
			label: __("Bottom", "ghub-video-lightbox"),
			icon: <CustomIcon icon="verticalBottom" />,
			value: "bottom",
		},
	];

	return (
		<PanelBody
			initialOpen={false}
			title={__("Play Button", "ghub-video-lightbox")}
		>
			<BaseControl label={__("Button Shape", "ghub-video-lightbox")}>
				<ButtonGroup className="gutenberghub-video-button-group">
					{playButtonShape.map((playBtnShape) => {
						return (
							<Button
								showTooltip
								isPressed={attributes.buttonShape === playBtnShape.id}
								label={playBtnShape.name}
								onClick={() => {
									setAttributes({
										buttonShape: playBtnShape.id,
									});
								}}
							>
								{playBtnShape.icon}
							</Button>
						);
					})}
				</ButtonGroup>
			</BaseControl>

			<UnitControl
				label={__("Size", "ghub-video-lightbox")}
				value={attributes.ghubPlayButtonSize}
				onChange={(newValue) => setAttributes({ ghubPlayButtonSize: newValue })}
				min={0}
			/>

			<BaseControl label={__("Icon Color", "ghub-video-lightbox")}>
				<ColorPalette
					colors={defaultColors}
					enableAlpha
					value={attributes.ghubPlayIconColor}
					onChange={(newColor) =>
						setAttributes({ ghubPlayIconColor: newColor })
					}
				/>
			</BaseControl>

			<BaseControl label={__("Background", "ghub-video-lightbox")}>
				<ColorPalette
					colors={defaultColors}
					enableAlpha
					value={attributes.ghubPlayIconBgColor}
					onChange={(newColor) =>
						setAttributes({ ghubPlayIconBgColor: newColor })
					}
				/>
			</BaseControl>

			<ToggleGroupControl
				__nextHasNoMarginBottom
				label={__("Vertical Position", "ghub-video-lightbox")}
				value={attributes.ghubPlayButtonVerticalPosition}
				onChange={(newValue) => {
					setAttributes({ ghubPlayButtonVerticalPosition: newValue });
				}}
			>
				{verticalPositionOpt.map(({ value, icon, label }) => {
					return (
						<ToggleGroupControlOptionIcon
							key={value}
							value={value}
							icon={icon}
							label={label}
						/>
					);
				})}
			</ToggleGroupControl>

			<ToggleGroupControl
				__nextHasNoMarginBottom
				label={__("Horizontal Position", "ghub-video-lightbox")}
				value={attributes.ghubPlayButtonHorizontalPosition}
				onChange={(newValue) => {
					setAttributes({ ghubPlayButtonHorizontalPosition: newValue });
				}}
			>
				{justificationPositionOpt.map(({ value, icon, label }) => {
					return (
						<ToggleGroupControlOptionIcon
							key={value}
							value={value}
							icon={icon}
							label={label}
						/>
					);
				})}
			</ToggleGroupControl>
		</PanelBody>
	);
}

export default PlayButton;
